var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCodeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 10.6047C48 7.79163 46.8837 5.0947 44.8945 3.10549C42.9053 1.11628 40.2084 0 37.3954 0H10.6047C7.79163 0 5.0947 1.11628 3.10549 3.10549C1.11628 5.0947 0 7.79163 0 10.6047V37.3954C0 40.2084 1.11628 42.9053 3.10549 44.8945C5.0947 46.8837 7.79163 48 10.6047 48H37.3954C40.2084 48 42.9053 46.8837 44.8945 44.8945C46.8837 42.9053 48 40.2084 48 37.3954V10.6047ZM44.6512 10.6047V37.3954C44.6512 39.3198 43.8876 41.1661 42.5258 42.5258C41.1661 43.8876 39.3198 44.6512 37.3954 44.6512H10.6047C8.68019 44.6512 6.83386 43.8876 5.47423 42.5258C4.11237 41.1661 3.34884 39.3198 3.34884 37.3954V10.6047C3.34884 8.68019 4.11237 6.83386 5.47423 5.47423C6.83386 4.11237 8.68019 3.34884 10.6047 3.34884H37.3954C39.3198 3.34884 41.1661 4.11237 42.5258 5.47423C43.8876 6.83386 44.6512 8.68019 44.6512 10.6047Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0895 15.4335L19.7314 31.5079C19.4412 32.3853 19.9145 33.3341 20.7919 33.6266C21.6692 33.9168 22.6181 33.4435 22.9106 32.5661L28.2687 16.4917C28.5589 15.6143 28.0856 14.6655 27.2082 14.373C26.3308 14.0828 25.382 14.5561 25.0895 15.4335Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8539 19.8251L35.0265 24L30.8539 28.1749C30.1997 28.8268 30.1997 29.8895 30.8539 30.5414C31.5058 31.1956 32.5685 31.1956 33.2204 30.5414L38.5785 25.1833C39.2327 24.5291 39.2327 23.4709 38.5785 22.8168L33.2204 17.4586C32.5685 16.8045 31.5058 16.8045 30.8539 17.4586C30.1997 18.1105 30.1997 19.1732 30.8539 19.8251Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7794 17.4586L9.42127 22.8168C8.76713 23.4709 8.76713 24.5291 9.42127 25.1833L14.7794 30.5414C15.4313 31.1956 16.494 31.1956 17.1459 30.5414C17.8001 29.8895 17.8001 28.8268 17.1459 28.1749L12.9733 24L17.1459 19.8251C17.8001 19.1732 17.8001 18.1105 17.1459 17.4586C16.494 16.8045 15.4313 16.8045 14.7794 17.4586Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeIcon);
export default __webpack_public_path__ + "static/media/codeIcon.1a7e9309a40ef0a069e8185d7a509054.svg";
export { ForwardRef as ReactComponent };